import { render } from "./SegPolicies.vue?vue&type=template&id=0403348c&scoped=true"
import script from "./SegPolicies.vue?vue&type=script&lang=js"
export * from "./SegPolicies.vue?vue&type=script&lang=js"

import "./SegPolicies.vue?vue&type=style&index=0&id=0403348c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0403348c"

export default script